import React from 'react';
import './src/index.css';
import { wrapRootElement as wrap } from './src/wrap-root-element';
import { SeoLayout } from './src/layouts/SeoLayout';

export const wrapRootElement = wrap;

// Inject default SEO tags on every page in Gatsby v3
export const wrapPageElement = ({ element, props }) => (
  <SeoLayout pageProps={props}>{element}</SeoLayout>
);

// Load GTM after React hydration is complete so it does not block
// the main thread during initial render (reduces TBT).
// Consent-mode defaults are already in <head> from gatsby-ssr.js, so
// dataLayer events pushed before this function fires are queued and
// replayed automatically by GTM when it initialises.
export const onInitialClientRender = () => {
  const GTM_ID = process.env.GATSBY_GTM_ID || 'GTM-MHXFVZM9';
  if (!GTM_ID) return;

  const loadGTM = () => {
    // Guard: only inject once
    if (document.getElementById('gtm-deferred')) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    const first = document.getElementsByTagName('script')[0];
    const tag = document.createElement('script');
    tag.id = 'gtm-deferred';
    tag.async = true;
    tag.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
    first.parentNode.insertBefore(tag, first);
  };

  // requestIdleCallback: fires when browser has spare cycles post-hydration.
  // timeout=4000 ensures GTM still loads within 4 s on slow machines.
  // Safari fallback: setTimeout with a short delay.
  if ('requestIdleCallback' in window) {
    requestIdleCallback(loadGTM, { timeout: 4000 });
  } else {
    setTimeout(loadGTM, 1000);
  }
};

// Gatsby browser APIs to handle client-side functionality
export const onRouteUpdate = ({ location }) => {
  // push a virtual pageview to GTM when the user navigates within the SPA
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'pageview',
      page: location.pathname + location.search,
    });
  }
};
